import { render, staticRenderFns } from "./BaseFooterCategory.vue?vue&type=template&id=4f573a0d&"
import script from "./BaseFooterCategory.vue?vue&type=script&lang=js&"
export * from "./BaseFooterCategory.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterCategory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports